"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealHealthyFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealHealthyFilled = function MealHealthyFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.966 34.36l-.043.045S12.2 27.987 7.71 22.5h7.011l.229-.684 1.136-3.41 2.986 7.465.929 2.322.928-2.322 2.173-5.432 1.005 2.008.276.553h7.493c-4.535 5.369-11.798 11.405-11.798 11.405l-.043-.046-.036.035-.032-.035zM33.45 21c.192-.265.372-.526.54-.781 2.59-3.928 3.282-8.768 0-12.112a8.29 8.29 0 00-11.88 0l-2.076 2.121-.036-.035-.032.035-2.076-2.12a8.291 8.291 0 00-11.88 0c-3.282 3.343-2.59 8.183 0 12.11.06.094.123.188.188.282h7.081l1.772-5.316.864-2.59 1.014 2.535L20 22.807l2.072-5.178.827-2.068.995 1.992L25.618 21h7.832z",
    fill: "#97BA1E"
  }));
};

exports.MealHealthyFilled = MealHealthyFilled;
var _default = MealHealthyFilled;
exports.default = _default;